import {  faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import { Button,  Table } from "react-bootstrap";
import DatePickerCustom from "../../../utilities/Form/datepicker";
import Input from "../../../utilities/Form/input";
import Select from "react-select";
import CurrencyInput from "react-currency-input-field";
import InputNumber from "../../../utilities/Form/InputNumber";
import Swal from "sweetalert2";
import i18n from "../../../../i18n";

export class FormConvertionLive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      qty: 0,
      qtyUse: 0,
      currentUnit: null,
      unit: false,
      batchNo: "",
      bandNo: "",
      expDate: new Date(),
      unitList: [],
      unitText: i18n.t("Select Unit"),
      arrayDetail: [
        {
          unitValue: null,
          qty: 0,
        },
      ],
      isUpdate: 0,
    };
    this.handlerSelect = this.handlerSelect.bind(this);
    this.runSubmit = this.runSubmit.bind(this);
    this.handler = this.handler.bind(this);
  }
  handlerDateTime(e, name) {
    var key = name;
    var value = e;
    this.setState({
      [key]: value,
    });
  }
  handlerSelect(e, name, currentState) {
    var key = name;
    var value = null;
    if (e != null) {
      value = e.value;
    }
    this.setState({
      ...this.state,
      [key]: value,
    });
    this.setState({ [currentState]: e });
  }
  calculateAll() {
    const { data } = this.props;
    let qty = parseFloat(data.qty);
    let qtyUse = 0;
    let currentConvertion = parseFloat(this.state.currentUnit.convertion) || 0;
    for (var i = 0; i < this.state.arrayDetail.length; i++) {
      var convertion =
        this.state.arrayDetail[i].unitValue != null
          ? parseFloat(this.state.arrayDetail[i].unitValue.convertion) || 0
          : 0;
      var qtydetail = parseFloat(this.state.arrayDetail[i].qty) || 0;
      qtyUse += qtydetail * convertion;
    }
    qtyUse = qtyUse / currentConvertion;
    qty -= qtyUse;
    this.setState({
      qty: qty,
      qtyUse: qtyUse,
    });
  }
  runSubmit() {
    if (this.state.qtyUse > 0) {
      let detail = [];

      for (var i = 0; i < this.state.arrayDetail.length; i++) {
        if (this.state.arrayDetail[i].unitValue != null) {
          detail.push(this.state.arrayDetail[i]);
        }
      }
      this.state.result = {
        qty: this.state.qty,
        batchNo: this.state.batchNo,
        bandNo: this.state.bandNo,
        expDate: this.state.expDate,
        qtyUse: this.state.qtyUse,
        detail: detail,
      };
      return this.state.result;
    } else {
      this.alertError("Info", i18n.t("Qty Receive must be more than 0"), "info");
    }
    return null;
  }

  handlerSelectArray(e, name, i, arrayname) {
    const arr = [...this.state[arrayname]];
    const objectss = arr[i];
    if (e == null) {
      objectss[name] = null;
    } else {
      objectss[name] = e;
    }
    this.setState(arr);
  }
  handlerCurrencyArray(e, name, i, arrayname) {
    const arr = [...this.state[arrayname]];
    const objectss = arr[i];
    objectss[name] = e;

    this.setState(arr);
  }

  renderDetail(detail, i) {
    const { data, unitList } = this.props;
    return (
      <React.Fragment key={"detail" + i}>
        <tr>
          <td>
            <Select
              isClearable={true}
              name={"unit"}
              required={true}
              className={""}
              size={4}
              onChange={async (e) => {
                await this.handlerSelectArray(e, "unitValue", i, "arrayDetail");
                if (e == null) {
                  await this.handlerCurrencyArray(0, "qty", i, "arrayDetail");
                }
                await this.calculateAll();
              }}
              options={this.state.unitList}
              value={detail.unitValue}
              placeholder={this.state.unitText}
            />
          </td>
          <td>
            <CurrencyInput
              id={"qty" + i}
              name="qty"
              placeholder={i18n.t("Qty Receive")}
              defaultValue={0}
              value={detail.qty}
              disabled={detail.unitValue != null ? false : true}
              decimalsLimit={2}
              onValueChange={async (value, name) => {
                await this.handlerCurrencyArray(value, "qty", i, "arrayDetail");
                await this.calculateAll();
              }}
              className="form-control  form-control-sm text-end"
            />
          </td>
          <td>
            <Button
              variant="danger"
              className="btn btn-sm"
              onClick={(e) => this.removeArray(i, "arrayDetail")}
            >
              <FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
            </Button>
          </td>
        </tr>
      </React.Fragment>
    );
  }

  addArray(value, key) {
    const newRow = value;
    const arr = [...this.state[key], newRow];
    this.setState({
      ...this.state,
      [key]: arr,
    });
  }
  removeArray(i, key) {
    const arr = this.state[key].filter((obj, index) => {
      return index !== i;
    });
    this.setState(
      {
        ...this.state,
        [key]: arr,
      },
      async () => {
        await this.calculateAll();
      }
    );
  }
  alertError(title, message, icon) {
    Swal.fire({
      title: title,
      html: message,
      icon: icon,
    });
  }
  handler(e) {
    var key = e.target.name;
    var value = e.target.value;
    this.setState({
      [key]: value,
    });
  }
  render() {
    const { data, isNewRecord } = this.props;
    if (data != null && !isNewRecord) {
      if (this.state.isUpdate == 0) {
        this.state.unitList = data.unitList;
        if (data.unitList.length > 0) {
          let indexUnit = data.unitList.findIndex((e) => e.current == true);
          this.state.unit = data.unitList[indexUnit].label;
          this.state.currentUnit = data.unitList[indexUnit];
        }
        this.state.qty = data.qty;
        this.state.expDate = data.expDate;
        this.state.batchNo = data.batchNo;
        this.state.bandNo = data.bandNo;

        this.state.arrayDetail = data.convertionDetail;
        this.calculateAll();
        this.state.isUpdate = 1;
      }
    }
    return (
      <React.Fragment>
        <form>
          <div className="row">
            <div className="col-4 mb-4">
              <Input
                type={"input"}
                name={"batchNo"}
                title={i18n.t("Batch No")}
                required
                value={this.state.batchNo}
                handler={(e) => this.handler(e)}
              />
            </div>
            <div className="col-4 mb-4">
              <Input
                type={"input"}
                name={"bandNo"}
                title={i18n.t("No. Band")}
                required
                value={this.state.bandNo}
                handler={(e) => this.handler(e)}
              />
            </div>
            <div className="col-4 mb-4">
              <DatePickerCustom
                name={"expDate"}
                title={i18n.t("Expired Date")}
                required={true}
                selected={this.state.expDate}
                onSelect={async (e) => {
                  await this.handlerDateTime(e, "expDate");
                }}
                onChange={(e) => {}}
                startDay={0}
                autoComplete={"off"}
                dateFormat="dd MMM yyyy"
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-6 mb-4">
              <Input
                type={"input"}
                name={"unit"}
                title={i18n.t("Unit")}
                required
                disabled
                value={this.state.unit}
                handler={this.handler}
              />
            </div>
            <div className="col-6 mb-4">
              <InputNumber
                id={"qty"}
                name="qty"
                title={i18n.t("Total Qty Receive")}
                placeholder={i18n.t("Qty")}
                defaultValue={0}
                value={this.state.qtyUse}
                decimalsLimit={2}
                disabled
                onValueChange={(value, name) => {}}
                className="form-control  form-control-sm text-end"
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-12">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>{i18n.t("Unit")}</th>
                    <th className="text-center">{i18n.t("Qty")}</th>
                    <th className="text-right"></th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.arrayDetail.map((detail, index) => {
                    return this.renderDetail(detail, index);
                  })}
                </tbody>
              </Table>
              <Button
                variant="success"
                onClick={(e) =>
                  this.addArray(
                    {
                      unitValue: null,
                      qty: 0,
                    },
                    "arrayDetail"
                  )
                }
              >
                {i18n.t("Add Convertion")}
              </Button>
            </div>
          </div>
        </form>
      </React.Fragment>
    );
  }
}

export default FormConvertionLive;
